import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';

function Preview({
  paperBg,
  questionColor,
  answerColor,
  stripColor,
  fontType,
  buttonColor,
  questionText,
  optionText,
  index,
  allQuest,
}) {
  // console.log('ini questionText', questionText);

  // let options = optionText.map((optT, i) => optT[i]);

  // console.log('ini options', optionText);
  console.log('ini all quest', allQuest);

  // {
  //   optionText.map((optT, i) => (
  //     <>
  //       {console.log('ini optionText', optT[i], 'ini I', i)}
  //       <h3 style={answerColor}>{optT[i]}</h3>
  //     </>
  //   ));
  // }

  const [valueOpt, setValueOpt] = useState('');
  var c = 'A';

  // console.log("INI QUES",allQuest.map((ques, i) => ques.questionText));

  return (
    <div>
      {allQuest.map((ques, i) => (
        <div className='mb-5 shadow-lg rounded-lg mr-20 w-full' style={paperBg}>
          <div className='rounded-t-lg h-4 mr-20' style={stripColor}></div>
          <div className='px-4 py-6'>
            <div className='flex'>
              <div className=' mr-3'>
                <p className='font-bold' style={questionColor}>
                  {i + 1}.
                </p>
              </div>
              <div className='mr-3 flex-wrap font-bold'>
                {ques.questionText ? (
                  <p style={questionColor}> {ques.questionText}</p>
                ) : (
                  <p style={questionColor}> Preview Pertanyaan</p>
                )}
              </div>
            </div>
            <div className='flex'>
              <div className='justify-center mr-3'>
                <h3 className='text-center'></h3>
              </div>
              <div className='ml-2'>
                <h5 className='text-gray-400 italic mt-3 mb-3'>
                  -- Jawaban --
                </h5>
              </div>
            </div>
            {ques.options.map((op, j) => (
              <div className='flex mt-3 mb-3'>
                <div className='justify-center mr-3'>
                  <h3 className='text-center'></h3>
                </div>
                <div className='justify-center'>
                  <h3 className='text-center mr-3' style={answerColor}>
                    <input
                      type={ques.questionType}
                      color='primary'
                      style={{ marginRight: '3px' }}
                      required={ques.type}
                      className='ml-7'
                      name={j}
                      disabled
                    />
                  </h3>
                </div>
                {ques.options[j].optionText ? (
                  <>
                    <div className='col-span-10'>
                      {ques.options[j].optionText}
                    </div>
                  </>
                ) : (
                  <div className='col-span-10'>Preview Option</div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <br />
    </div>
  );
}

export default Preview;
